<h1>Ultimate weapon upgrade calculator</h1>

<div class="result-wrapper">
  <div class="side-panel-container">
    <div class="form-container">
      <h2>Data:</h2>
      <div class="input-container">
        <p class="input-label">Simulate X times</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="simulationCount"
        />
      </div>
      <div class="input-container">
        <p class="input-label">FWC</p>
        <mat-slide-toggle
          class="checkbox-input"
          [(ngModel)]="priceProvider.isFwc"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Upgrade event</p>
        <mat-slide-toggle
          class="checkbox-input"
          [(ngModel)]="isUpgradeEvent"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Upgrade bonus %</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [max]="9999"
          [(ngModel)]="customUpgradeBonus"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Current upgrade level</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [max]="9"
          [(ngModel)]="currentUpgrade"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Target upgrade level</p>
        <input
          class="data-input"
          type="number"
          [min]="1"
          [max]="10"
          [(ngModel)]="targetUpgrade"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Current attempts</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="currentAttemptsIn"
        />
      </div>
      <div class="input-container">
        <p class="input-label">xPro cost</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.xProPrice"
        />
      </div>
      <div class="input-container">
        <p class="input-label">sunstone cost</p>
        <input
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.sunstonePrice"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="eron-cost">Eron cost</label>
        <input
          id="eron-cost"
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.eronPrice"
        />
      </div>
      <div class="input-container">
        <label class="input-label" for="mineral-cost">Mineral cost</label>
        <input
          id="mineral-cost"
          class="data-input"
          type="number"
          [min]="0"
          [(ngModel)]="priceProvider.mineralPrice"
        />
      </div>
      <div class="button-container">
        <button (click)="SimulateUpgrading()">Calculate</button>
      </div>
    </div>
    <div class="result-container">
      <h2>Results:</h2>
      <div class="results">
        <div class="result-row">
          <p class="bold">Total penya cost:&nbsp;</p>
          <p>{{ GetTotalPenyaCost() / simulationCount | number : "1.0-1" }}</p>
        </div>
        <br />
        <div class="result-row">
          <p class="bold">Total xPro cost:&nbsp;</p>
          <p>
            {{
              (GetXprosUsed() * priceProvider.xProPrice) /
                simulationCount | number : "1.0-1"
            }}
          </p>
        </div>
        <div class="result-row">
          <p class="bold">Total xPro's used:&nbsp;</p>
          <p>{{ GetXprosUsed() / simulationCount | number : "1.0-1" }}</p>
        </div>
        <br />
        <div class="result-row">
          <p class="bold">Total sunstone cost:&nbsp;</p>
          <p>{{ GetSunstonesUsed() * priceProvider.sunstonePrice / simulationCount | number : "1.0-1" }}</p>
        </div>
        <div class="result-row">
          <p class="bold">Total sunstones used:&nbsp;</p>
          <p>{{ GetSunstonesUsed() / simulationCount | number : "1.0-1" }}</p>
        </div>
        <br />
        <div class="result-row">
          <p class="bold">Total material cost:&nbsp;</p>
          <p>
            {{
              (GetEronsUsed() * priceProvider.eronPrice + GetMineralsUsed() * priceProvider.mineralPrice) /
                simulationCount | number : "1.0-1"
            }}
          </p>
        </div>
        <div class="result-row">
          <p class="bold">Total erons used:&nbsp;</p>
          <p>{{ GetEronsUsed() / simulationCount | number : "1.0-0" }}</p>
        </div>
        <div class="result-row">
          <p class="bold">Total minerals used:&nbsp;</p>
          <p>{{ GetMineralsUsed() / simulationCount | number : "1.0-0" }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="upgrade-chart">
    <canvas id="upgrade-data-chart"></canvas>
  </div>
</div>
